<template>
  <div class="call-pop-screen" v-if="isEnableCcWorkbench">
    <div class="call-pop-screen-call-section">
      <CallSection :workbench-config="workbenchConfig" />
    </div>
    <div class="call-pop-screen-meddle">
      <div class="meddle-header">
        <div class="meddle-header-left">
          <span class="meddle-header-left-title">{{ $t('callPopScreen.title') }}</span>
          <div class="follow-data">
            <div
              class="follow-data-item"
              v-for="(item, index) in showFollowData"
              :key="index"
            >{{item.label}}：{{ item.value }}</div>
          </div>
        </div>
        <div class="meddle-header-right">
          <el-button v-if="workbenchConfig && workbenchConfig.tabs.includes('call_plans')" size="mini" @click="isAddContactPlanShow = true">{{ $t('callPopScreen.addContactPlan') }}</el-button>
        </div>
      </div>
      <div class="content">
        <template v-if="workbenchConfig">
          <PopLayout
            v-for="(item, index) in contentList"
            v-show="item.id === curCall.id"
            :key="index"
            :item="item"
            :workbenchConfig="workbenchConfig"
            :isQidianShowWo="isQidianShowWo"
          />
        </template>
      </div>
    </div>
    <el-dialog
      title="　"
      :visible.sync="isAddContactPlanShow"
      width="520px"
      class="AddContactPlanDialog"
    >
      <iframe :src="addContactPlanSrc"></iframe>
    </el-dialog>
  </div>
  <div class="disabledCcWorkbench" v-else>
    <el-empty
      :image="emptyImg"
      :description="$t('callPopScreen.ccWorkbenchDisabled')"
    ></el-empty>
  </div>
</template>

<script>
import { getSystemCcWorkbench } from "@/api";
import { getIvrAlongData } from "@/api/crm";
import CallSection from './callSection'
import PopLayout from './popLayout'
import { getShortId } from '@/utils'
import emptyImg from '@/assets/images/noPurchase.png'
import { mapActions, mapGetters } from 'vuex';
import dayjs from "dayjs";
import _ from 'lodash'
const isValidVal = (val) => {
  return ![undefined, '', null].includes(val)
}
export default {
  components: {
    CallSection,
    PopLayout
  },
  data() {
    return {
      workbenchConfig: null,
      contentList: [], // 右侧存储tab
      contentSortIndex: [], //contentList排序的index
      tempContentIds: [], // 存储临时content id
      /**
       * curCall应该包含的字段:
       * id 唯一key
       * cle_id 客户id
       * cle_name 客户名称
       * cle_phone 客户号码
       * call_id
       */
      curCall: {},
      recordData: {}, // 组装随路数据
      fillTicketCallIds: [], // 填写过工单的call_id
      fillContactCallIds: [], // 填写过跟进记录的call_id
      emptyImg,
      saveIvrAlongData: {},
      saveExtraParams: {},
      isAddContactPlanShow: false ,// 添加联系计划
      isQidianShowWo: location.hash.includes('qidian/agent') ? false : true
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'callRecords']),
    businessConfig() {
      return this.workbenchConfig && this.workbenchConfig.business_config || {}
    },
    // 是否开启新版电话弹屏
    isEnableCcWorkbench() {
      return this.$store.state.otherSystemConfig && this.$store.state.otherSystemConfig.isEnableCcWorkbench
    },
    followData() {
      return this.workbenchConfig && this.workbenchConfig.follow_data || []
    },
    addContactPlanSrc() {
      const { my: { ektv3_page }, } = this._config.URL;
      return ektv3_page + '/ekt/addContact'
    },
    showFollowData() {
      const ret = []
      this.followData.forEach((item) => {
        const name = item.name
        let value = _.get(this.recordData, name)
        if(name === 'call_time') {
          value = this.formatAbbrDate(value)
        }
        if(isValidVal(value)) {
          ret.push({
            label: item.label,
            value
          })
        }
      })
      return ret
    }
  },
  provide() {
    return {
      curCall: () => this.curCall,
      setCurCall: this.setCurCall,
      businessConfig: () => this.businessConfig,
      fillTicketCallIds: () => this.fillTicketCallIds,
      fillContactCallIds: () => this.fillContactCallIds
    }
  },
  watch: {
    curCall: {
      handler(call) {
        const findRecord = this.callRecords.find((record) => record.call_id === call.call_id) || {}
        const mtInfo = findRecord.mtInfo
        if(call.call_id && mtInfo) {
          this.getIvrAlongData(call.call_id, mtInfo)
        }
      },
      immediate: true
    }
  },
  created() {
    // 获取新电话工作台配置
    this.getSystemCcWorkbench()
    // 监听页面发来的消息
    window.addEventListener('message', this.onMessage)
     if(location.hash.includes('qidian/agent')){
       window.parent.postMessage({
        type: 'ExtApp.TopMenu',
        method: 'getMessage', // 新增getMessage，处理iframe页面传参
        payload: ['showWo'] // 获取数据的key，支持后续拓展
      }, '*');
      }
  },

  beforeDestroy() {
    window.removeEventListener('message', this.onMessage)
  },
  methods: {
    ...mapActions(["setTodayCallCustomers"]),
    onMessage(event) {
      const postMsg = event.data
      const msgData = typeof postMsg == "string" ? JSON.parse(postMsg) : postMsg

     if (event.origin.substr(-13) === 'qidian.qq.com') {
        const postMsg = event.data.payload
        const msgData = typeof postMsg == "string" ? JSON.parse(postMsg) : postMsg
        if(msgData.hasOwnProperty('showWo')) {
          if(msgData.showWo === 1){
            this.isQidianShowWo = true
          }else {
            this.isQidianShowWo = false
          }
        }
      }else if(msgData.type === 'submit_ticket_success') {
        // 填补工单
        if(!this.fillTicketCallIds.includes(msgData.call_id) &&
          this.businessConfig.ticket &&
          this.businessConfig.ticket.enable &&
          this.businessConfig.ticket.flow_id === msgData.flow_id
        ) {
          this.fillTicketCallIds.push(msgData.call_id)
        }
      } else if(msgData.type === 'submit_contact_record_success') {
        // 填补跟进记录
        if(!this.fillContactCallIds.includes(msgData.call_id) &&
          this.businessConfig.contact_record &&
          this.businessConfig.contact_record.enable
        ) {
          this.fillContactCallIds.push(msgData.call_id)
        }
      } else if(msgData.type === 'call_pop_screen_tab_save_client') {
        // 监听客户信息tab更新客户信息
        if(msgData.client) {
          const item = msgData.client
          const clientInfo = {
            id: this.curCall.id,
            ...item
          }
          this.setCurCall({
            itemType: this.curCall.itemType,
            id: this.curCall.id,
            cle_id: item.cle_id,
            cle_name: item.cle_name,
            cle_phone: item.cle_phone,
            call_id: this.curCall.call_id,
            call_type: this.curCall.call_type
          })
          this._Bus.$emit("updClient", clientInfo);
        }
      } else if(msgData.type === 'call_pop_screen_tab_qidian_save_client') {
        // 监听企点客户信息tab更新客户信息
        if(msgData.cust_id) {
          if(!this.saveExtraParams[this.curCall.call_id]) this.saveExtraParams[this.curCall.call_id] = {}
          const phone = this.curCall.cle_phone
          if(phone === msgData.cust_mobile) {
            this.saveExtraParams[this.curCall.call_id].qidian_cust_id = msgData.cust_id
            this.saveExtraParams[this.curCall.call_id].qidian_cust_name = msgData.cust_name
            this.saveExtraParams[this.curCall.call_id].qidian_cust_mobile = msgData.cust_mobile
            this.saveExtraParams[this.curCall.call_id].qidian_socialAccountObj = msgData.socialAccountObj
            this.setCurCall({
              ...this.curCall
            })
          } else {
            // 否则，就在this.contentList中查找item.cle_phone === msgData.cust_mobile且this.saveExtraParams[item.call_id].qidian_cust_id不存在的item
            // 找到item后再赋值
            const targetIndex = this.contentList.findIndex((item) => {
              if(!item.call_id) return false
              const itemPhone = item.cle_phone
              if(itemPhone !== msgData.cust_mobile) return false
              const extra = this.saveExtraParams[item.call_id]
              return !extra || !extra.qidian_cust_id
            })
            if(targetIndex !== -1) {
              const targetItem = this.contentList[targetIndex]
              if(!this.saveExtraParams[targetItem.call_id]) this.saveExtraParams[targetItem.call_id] = {}
              this.saveExtraParams[targetItem.call_id].qidian_cust_id = msgData.cust_id
              this.saveExtraParams[targetItem.call_id].qidian_cust_name = msgData.cust_name
              this.saveExtraParams[targetItem.call_id].qidian_cust_mobile = msgData.cust_mobile
              this.saveExtraParams[targetItem.call_id].qidian_socialAccountObj = msgData.socialAccountObj
              // 更新对应contentList项的recordData，不切换curCall
              this.contentList.splice(targetIndex, 1, {
                ...targetItem,
                recordData: {
                  ...targetItem.recordData,
                  qidian_cust_id: msgData.cust_id,
                  qidian_cust_name: msgData.cust_name,
                  qidian_cust_mobile: msgData.cust_mobile,
                  qidian_socialAccountObj: msgData.socialAccountObj
                }
              })
            }
          }
          this.setTodayCallCustomers({ cle_name: msgData.cust_name, cle_phone: msgData.cust_mobile })
        } else {
          this.setTodayCallCustomers({ cle_name: msgData.cust_name, cle_phone: msgData.cust_mobile })
        }
      }
    },
    getSystemCcWorkbench() {
      getSystemCcWorkbench().then(res => {
        if(res.code === 0) {
          this.workbenchConfig = res.data.workbench_config
        }
      })
    },
    // 保存的随路数据
    getRecordData() {
      const findRecord = this.callRecords.find((record) => record.call_id === this.curCall.call_id) || {}
      const mtInfo = findRecord.mtInfo || {}
      const associatdata = this.saveIvrAlongData[this.curCall.call_id] || {}
      const extraParams = this.saveExtraParams[this.curCall.call_id] || {}
      const callerAreaNameArr = mtInfo.CallerAreaName ? mtInfo.CallerAreaName.split(' ') : []
      const CallerProvinceName = callerAreaNameArr[0]
      const CallerCityName = callerAreaNameArr[1]
      return {
        call_id: this.curCall.call_id, // 通话的唯一标识
        call_type: this.curCall.call_type, // 呼入或呼出
        caller: associatdata.phone, // 呼入时的来电的主叫号码
        caller_areaname: mtInfo.CallerAreaName, // 来电号码的归属地名称，格式为：北京 北京
        caller_areacode: mtInfo.CallerAreaCode, // 来电号码的归属地区号，格式为：0576
        caller_province_name: CallerProvinceName, // 来电号码的归属地的省的名称，格式为：浙江
        caller_city_name: CallerCityName, // 来电号码的归属地的市的名称，格式为：杭州
        call_time: mtInfo.Time, // 来电进线的时间或外呼开始的时间，单位秒
        server_num: mtInfo.ServNum, // 来电的中继号码
        server_400: mtInfo.HotlineNum, // 来电的 400 号码
        session_id: undefined, // 会话id
        department_name: this.userInfo.deptName, // 用户部门名称
        department_id: this.userInfo.deptId, // 用户部门id
        role_name: this.userInfo.roleName, // 用户角色名称
        role_id: this.userInfo.roleId, // 用户角色id
        user_id: this.userInfo.userId, // 座席id
        user_num: this.userInfo.userNum, // 座席工号
        user_name: this.userInfo.userName, // 座席名称
        vcc_id: this.userInfo.vccId, // 企业id
        vcc_code: this.userInfo.vccCode, // 企业代码
        current_time: Date.now(), // 当前时间，单位毫秒
        queue_name: associatdata.queue_name, // 进线分配的技能组名称（包括呼叫中心和在线客服）
        queue_id: mtInfo.QueId, // 进线分配的技能组 ID（包括呼叫中心和在线客服）
        cle_id: this.curCall.cle_id, // 客户id
        cle_name: this.curCall.cle_name, // 客户名称
        cle_phone: this.curCall.cle_phone, // 客户号码
        user_data: mtInfo.UserData,
        mt_info: encodeURIComponent(JSON.stringify(mtInfo)), //新弹屏判断通话生成使用
        // 企点
        qidian_cust_id: extraParams.qidian_cust_id || '', // 企点客户id（企点打开saas，才会有值）
        qidian_cust_name: extraParams.qidian_cust_name || '', // 企点客户name（企点打开saas，才会有值）
        qidian_cust_mobile: extraParams.qidian_cust_mobile || '', // 企点客户手机号（企点打开saas，才会有值）
        qidian_socialAccountObj: extraParams.qidian_socialAccountObj || {}, // 企点socialAccountObj对象（企点打开saas，才会有值）
      }
    },
    setCurCall(call, isSwitchClient) {
      if(!isSwitchClient || call.id === this.curCall.id) {
        this.curCall = call
      }
      const isTemp = !['todayCall'].includes(call.itemType)
      const data = this.getRecordData()
      this.recordData = data
      // 过滤临时存储的tab
      this.contentList.forEach((item, index) => {
        if(this.tempContentIds.includes(item.id)) {
          this.contentList.splice(index, 1, {})
        }
      })
      const index = this.contentList.findIndex((item) => item.recordData && item.id === call.id)
      if(index !== -1) {
        this.contentList.splice(index, 1, {
          ...call,
          recordData: data,
          id: call.id
        })
        const i1 = this.contentSortIndex.findIndex((i) => i === index)
        if(i1 !== -1) {
          this.contentSortIndex = [...this.contentSortIndex.slice(0, i1), ...this.contentSortIndex.slice(i1 + 1), index]
        }
      } else {
        if(this.contentSortIndex.length >= 5 && !isTemp) {
          const i2 = this.contentSortIndex.shift()
          this.contentList.splice(i2, 1, {})
        }
        if(!isTemp) {
          this.contentSortIndex.push(this.contentList.length)
        } else {
          this.tempContentIds.push(call.id)
        }
        this.contentList.push({
          ...call,
          recordData: data,
          id: call.id
        })
      }
    },
    formatAbbrDate(timestamp) {
      if(!timestamp) return ''
      if(!/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(timestamp)) {
        timestamp = timestamp * 1000
      }
      const farmat = 'YYYY-MM-DD HH:mm:ss'
      // // 当天
      // if(dayjs().isSame(dayjs(timestamp), 'day')) {
      //   return dayjs(timestamp).format('HH:mm:ss')
      // }
      // // 昨天
      // if(dayjs().isSame(dayjs(timestamp + 24 * 60 * 60 * 1000), 'day')) {
      //   return '昨天'
      // }
      return dayjs(timestamp).format(farmat)
    },
    getIvrAlongData(callId, mtInfo) {
      const { my: { crm_page } } = this._config.URL;
      if(!this.saveIvrAlongData[callId]) {
        getIvrAlongData(crm_page, { call_id: callId, mt_info: mtInfo }).then(res => {
          if(res.code === 200) {
            this.saveIvrAlongData[this.curCall.call_id] = res.data
            const index = this.contentList.findIndex(con => con.call_id === callId)
            if(index !== -1) {
              const data = this.getRecordData()
              this.contentList.splice(index, 1, {
                ...this.contentList[index],
                recordData: data
              })
              if(this.curCall.call_id === callId) {
                this.recordData = data
              }
            }
          }
        }).catch(error => console.error(error));
      }
    }
  }
}
</script>

<style lang="less" scoped>
.call-pop-screen {
  display: flex;
  width: 100%;
  height: 100%;
  background: #fff;
  * {
    vertical-align: unset;
  }
  .call-pop-screen-call-section {
    flex-shrink: 0;
    width: 320px;
    border-right: 1px solid #EBEDF0;
  }
  .call-pop-screen-meddle {
    flex: 1;
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 0 16px;
    & > .meddle-header {
      position: relative;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
      width: 100%;
      min-height: 48px;
      padding: 8px 0;
      padding-left: 12px;
      color: #323233;
      font-size: 14px;
      font-weight: 600;
      box-sizing: border-box;
      &::before {
        content: '';
        position: absolute;
        left: 0;
        display: block;
        width: 4px;
        height: 16px;
        margin-right: 8px;
        background: #0090ff;
      }
      .meddle-header-left {
        display: flex;
        align-items: center;
        gap: 8px;
        &-title {
          flex-shrink: 0;
        }
        .follow-data {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 8px;
          &-item {
            display: flex;
            align-items: center;
            height: 20px;
            padding: 0 7px;
            color: #0074D9;
            font-size: 12px;
            border-radius: 4px;
            border: 1px solid #9EC9FA;
            background: #E6F8FF;
          }
        }
      }
      .meddle-header-right {
        display: flex;
        align-items: center;
        gap: 8px;
      }
    }
    .content {
      flex: 1;
      width: 100%;
      height: 0;
      display: flex;
    }
  }
  .AddContactPlanDialog {
    /deep/ .el-dialog__body {
      height: 516px;
      max-height: calc(100vh - 54px - 60px - 180px);
      padding-top: 0;
    }
  }
}
.disabledCcWorkbench {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/view/Home/callPopScreenTab/index.vue